import { Helmet } from "react-helmet";
import Navbar from "../components/universal/navbar";
import Header from "../components/restorative-dentistry/hero";
import WhatAndWhy from "../components/restorative-dentistry/what-and-why";
import Process from "../components/restorative-dentistry/process";
import AfterCare from "../components/restorative-dentistry/aftercare";
import CTA from "../components/restorative-dentistry/cta";
import Contact from "../components/universal/contact";
import Footer from "../components/universal/footer";
import QuestionRestorative from "../components/restorative-dentistry/Question";

function Index() {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "Service",
    name: "Restorative Dentistry in Ilkley, West Yorkshire | Regent Dental",
    serviceType: "Restorative Dentistry",
    url: "https://www.regent-dental.co.uk/restorative-dentistry",
    description:
      "Restorative dentistry at Regent Dental focuses on repairing and restoring damaged or missing teeth to restore function and aesthetics.",
    provider: {
      "@type": "LocalBusiness",
      "@id": "http://regent-dental.co.uk/#localbusiness",
      name: "Regent Dental",
      image:
        "https://www.regent-dental.co.uk/static/media/3.4c51da854dc4cc666630.png",
      url: "http://regent-dental.co.uk/",
      telephone: "+01943 661331",
      openingHours: "Mo-Fr 09:00-17:00",
      priceRange: "$$",
      sameAs: [
        "https://www.facebook.com/people/Regent-Dental/61564954080373/",
        "https://www.instagram.com/regentdental_ilkley/",
        "https://g.co/kgs/EY9shTo",
      ],
      address: {
        "@type": "PostalAddress",
        streetAddress: "2A Regent Rd",
        addressLocality: "Ilkley",
        addressRegion: "England",
        postalCode: "LS29 9EA",
        addressCountry: {
          "@type": "Country",
          name: "UK",
        },
      },
      areaServed: [
        { "@type": "Place", name: "Ilkley" },
        { "@type": "Place", name: "Keighley" },
        { "@type": "Place", name: "Skipton" },
        { "@type": "Place", name: "Otley" },
        { "@type": "Place", name: "Silsden" },
      ],
    },
  };
  const schemaData2 = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "What is restorative dentistry?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Restorative dentistry focuses on repairing and rebuilding teeth that are damaged, decayed, or missing - helping you to regain a healthy, functional, and confident smile.",
        },
      },
      {
        "@type": "Question",
        name: "What treatments are considered restorative dentistry?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Restorative treatments include fillings, crowns, bridges, dental implants, dentures, and root canal therapy - all tailored to restore your teeth beautifully.",
        },
      },
      {
        "@type": "Question",
        name: "How do I know if I need restorative dental treatment?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "If you have a broken, painful, missing or heavily worn tooth, you might benefit from restorative care. We’ll assess your teeth carefully and recommend the best options for you.",
        },
      },
      {
        "@type": "Question",
        name: "Will restorative treatment hurt?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "We take great pride in delivering gentle, comfortable care. Whether you’re having a small filling or a full restoration, we’ll make sure you feel relaxed and pain-free throughout your visit.",
        },
      },
      {
        "@type": "Question",
        name: "How long do dental restorations last?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "With good oral hygiene and regular check-ups, restorations such as crowns and bridges can last many years. We’ll guide you on how best to care for your dental work.",
        },
      },
      {
        "@type": "Question",
        name: "Are there natural-looking options for restorations?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Yes! We use high-quality, tooth-coloured materials so your restorations look beautifully natural and blend seamlessly with your smile.",
        },
      },
      {
        "@type": "Question",
        name: "Can you replace old metal fillings or crowns?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Absolutely. Many patients choose to replace old metal restorations with modern, aesthetic alternatives for a more natural and discreet appearance.",
        },
      },
      {
        "@type": "Question",
        name: "What’s the difference between a crown and a bridge?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "A crown is a cap that covers and protects a damaged tooth, while a bridge is used to replace one or more missing teeth by anchoring onto neighbouring teeth.",
        },
      },
      {
        "@type": "Question",
        name: "Can missing teeth be permanently replaced?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Yes, dental implants offer a permanent and highly realistic solution for missing teeth. We’d be delighted to discuss whether they’re right for you during a consultation.",
        },
      },
      {
        "@type": "Question",
        name: "How do I get started with restorative dentistry?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Simply book an appointment with us. We’ll take the time to listen to your concerns, carry out a thorough examination, and create a personalised treatment plan just for you.",
        },
      },
    ],
  };

  return (
    <div>
      <Helmet>
        <title>
          Restorative Dentistry in Ilkley, West Yorkshire | Regent Dental
        </title>
        <meta
          name="description"
          content="Restore your smile’s function and beauty with our complete restorative dentistry services, offering crowns, bridges, dentures, and personalized dental care."
        />
        <link
          rel="canonical"
          href="https://www.regent-dental.co.uk/restorative-dentistry"
        />
        <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
        <script type="application/ld+json">
          {JSON.stringify(schemaData2)}
        </script>
      </Helmet>
      <Navbar />
      <Header />
      <WhatAndWhy />
      <Process />
      <AfterCare />
      <QuestionRestorative />
      <CTA />
      <Contact />
      <Footer />
    </div>
  );
}

export default Index;
